import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2219_holiday_calendar_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Add Holiday Calendar",
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "holiday_calendar_add",
                TableName: "holiday_calendar",
                DisplayName: "Holiday Calendar",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "calendar_name",
                        label: "Calendar Name",
                        placeholder: "e.g. Corporate Holidays 2024",
                        required: true,
                        maxLength: 80,
                        BindValue: "calendar_name",
                        Json_Attribute: "calendar_name",
                    } as any,
                    {
                        componentType: ComponentType.SELECT_DROPDOWN,
                        name: "calendar_year",
                        label: "Calendar Year",
                        placeholder: "Select Year",
                        required: true,
                        dynamicYears: true,
                        options: [],
                        BindValue: "calendar_year",
                        Json_Attribute: "calendar_year",
                    } as any,
                    {
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        name: "transaction_branch_id",
                        label: "Applicable Branch/Location",
                        placeholder: "Select Branch (Optional)",
                        required: false,
                        lookupName: "branches",
                        BindValue: "transaction_branch_id",
                        Json_Attribute: "transaction_branch_id",
                    } as any,
                    {
                        componentType: ComponentType.TEXT_AREA,
                        name: "description",
                        label: "Description",
                        placeholder: "Optional description about this calendar",
                        required: false,
                        rows: 3,
                        maxLength: 500,
                        BindValue: "description",
                        Json_Attribute: "description",
                    } as any,
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    justifyContent: "flex-end",
                    padding: 10,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Create Calendar",
                        onPressAction: "save",
                        style: {
                            backgroundColor: "var(--primary-green)",
                            widthMode: "wrap",
                        },
                    } as any,
                ],
            },
        ],
    },
];
